import { render } from "./Pengecualian.vue?vue&type=template&id=7b0fd266"
import script from "./Pengecualian.vue?vue&type=script&lang=js"
export * from "./Pengecualian.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__